import {createSvgIcon} from "@mui/material";
import {useId} from "react";

const SearchIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <IconContent />
  </svg>,
  'Search'
)

function IconContent() {
    const clipId = useId();

    return (
        <>
            <g clipPath={`url(#${clipId})`}>
                <path
                    d="M15.4898 14.5735L11.6818 10.6129C12.6609 9.44901 13.1973 7.98455 13.1973 6.45999C13.1973 2.89801 10.2993 0 6.73734 0C3.17535 0 0.277344 2.89801 0.277344 6.45999C0.277344 10.022 3.17535 12.92 6.73734 12.92C8.07456 12.92 9.34886 12.5167 10.4384 11.751L14.2753 15.7416C14.4357 15.9082 14.6514 16 14.8825 16C15.1013 16 15.3089 15.9166 15.4665 15.7649C15.8013 15.4428 15.8119 14.9085 15.4898 14.5735ZM6.73734 1.68522C9.37021 1.68522 11.5121 3.82713 11.5121 6.45999C11.5121 9.09286 9.37021 11.2348 6.73734 11.2348C4.10447 11.2348 1.96256 9.09286 1.96256 6.45999C1.96256 3.82713 4.10447 1.68522 6.73734 1.68522Z"
                    fill="currentColor"/>
            </g>
        </>
    );
}

export default SearchIcon
